module.exports = __webpack_public_path__ + "img/20_72.4874882d.png";